import { Calendar } from "@mantine/dates";
// TODO Calendar styling & default props
export const calendarProps = Calendar.extend({});
